import React, { Component } from 'react';
import { IonLabel, IonCol, withIonLifeCycle } from '@ionic/react';

import api from '../../../../services/api';
import { synchronizeData } from '../../../../utils/synchronizeData';

import Card from '../../Card';
import Loading from '../../../Loading';

import './style.css';

class CardNfe extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      data: null,
    };
  }

  apiCall = () => {
    this.setState({ loading: true });
    api
      .get('/dashboard/nfes')
      .then(({ data }) => {
        this.setState({
          data: data[0],
          loading: false,
        });
      })
      .catch(err => {
        this.setState({ loading: false });
      });
  };

  componentDidMount() {
    this.apiCall();
    synchronizeData(this.apiCall);
  }

  render() {
    const { data, loading } = this.state;
    return (
      <>
        <Card
          className="card card__light"
          title="NF-e Mensal"
          iconName="icon-nfe"
          dashboardCard>
          {loading ? (
            <Loading />
          ) : (
            <div>
              <IonCol className="main-item">
                <div className="container">
                  <IonLabel color="dark" className="label">
                    Emitidas:
                  </IonLabel>
                  <IonLabel color="primary" className="value">
                    {data && data.NFES_EMITIDAS}
                  </IonLabel>
                </div>
              </IonCol>
              <div className="main-section">
                <div className="item">
                  <IonLabel color="dark" className="label">
                    Autorizadas
                  </IonLabel>
                  <IonLabel color="primary" className="value">
                    {data && data.NFES_AUTORIZADAS}
                  </IonLabel>
                </div>
                <div className="item">
                  <IonLabel color="dark" className="label">
                    Canceladas
                  </IonLabel>
                  <IonLabel color="primary" className="value">
                    {data && data.NFES_CANCELADAS}
                  </IonLabel>
                </div>
                <div className="item">
                  <IonLabel color="dark" className="label">
                    Pendentes
                  </IonLabel>
                  <IonLabel color="primary" className="value">
                    {data && data.NFES_PENDENTES}
                  </IonLabel>
                </div>
              </div>
            </div>
          )}
        </Card>
      </>
    );
  }
}

export default withIonLifeCycle(CardNfe);
